import React from 'react';
import { createRoot } from 'react-dom/client';

import { SidebarProvider } from 'src/context/SidebarContext';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from 'src/App';

const root = createRoot(document.getElementById('root') as Element);

root.render(
  <React.StrictMode>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
